import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';

export default function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-orange-50 via-amber-50 to-orange-100 px-6 py-16">
      <div className="max-w-2xl text-center">
        <div className="mx-auto mb-8">
          <img src="/assets/images/logo.png" alt="Mrs Cater" className="mx-auto h-20 w-auto" />
        </div>
        <h1 className="text-4xl font-bold tracking-tight text-primary sm:text-5xl">Admin Console</h1>
        <p className="mt-4 text-base text-gray-700 sm:text-lg">
          Manage marketplace health, monitor orders, and support caterers across the Mrs Cater ecosystem. Sign in with a verified admin account to continue.
        </p>
        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/admin/onboarding"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-warm-md transition hover:bg-[#A84F1F]"
          >
            <Icon name="LogIn" size={18} /> Enter admin console
          </Link>
          <a
            href="mailto:support@mrscater.com"
            className="inline-flex items-center gap-2 rounded-full border-2 border-primary/40 px-5 py-3 text-sm font-semibold text-primary transition hover:border-primary hover:bg-primary/5"
          >
            <Icon name="LifeBuoy" size={18} /> Request access
          </a>
        </div>
        <p className="mt-6 text-xs text-gray-600">
          Access is restricted. Every action is logged to maintain compliance and customer trust.
        </p>
      </div>
    </div>
  );
}
